<template>
    <div>

        <div class="flex items-stretch">

            <!--<div class="bg-white w-64 p-2">
                <slot name="left"></slot>
            </div>-->

            <div class="flex-1">
                <slot></slot>
            </div>

        </div>

        <div class="py-2 px-8 flex justify-between border-t items-baseline">
            <div>
                <!--{{ list.length }}-->
                <!--<a @click="report.selected = []" class="hover:text-red"><i class="fa fa-trash-o"></i></a>-->
            </div>

            <div>
                {{ list.length }} Series selected
            </div>

            <div>
                <button @click="close" class="text-red-light px-4 py-2 rounded">
                    discard changes
                </button>

                <button @click="setSeries" class="bg-blue-dark text-white px-4 py-2 rounded">
                    <i class="fa fa-save fa-fw"></i>
                    apply changes
                </button>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "SeriesProvider",

        provide() {
            return {
                report: this.report,
            };
        },

        data: () => ({
            report: {
                selected: [],
                id: null,
            },
        }),

        computed: {
            list() {
                return this.report.selected.map(function (series) {
                    return series.originalCode;
                })
            }
        },

        created() {
            this.report.selected = this.$store.getters.allSeries;
        },

        methods: {
            setSeries() {
                this.$store.dispatch('setSeries', {list: this.list});

                this.close();
            },
            close() {
                this.$emit('close');
            }
        }
    }
</script>
